import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './ThemeProvider';
import { AuthProvider, useAuth } from './AuthContext';

import Header from './components/Header';
import Footer from './components/Footer';
import DocumentTitle from './components/DocumentTitle';
import Home from './pages/Home';
import Catalog from './pages/Catalog';
import ProductDetail from './pages/ProductDetail';
import PageView from './pages/PageView';
import CatalogPdfView from './pages/CatalogPdfView';
import Contact from './pages/Contact';
import News from './pages/News';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';

function ProtectedRoute({ children }) {
  const { user, loading, isAdmin } = useAuth();
  
  if (loading) {
    return <div className="loading">A carregar...</div>;
  }
  
  if (!user || !isAdmin) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<><Header /><Home /><Footer /></>} />
      <Route path="/page/:slug" element={<><Header /><PageView /><Footer /></>} />
      <Route path="/view-catalog/:slug" element={<><Header /><CatalogPdfView /><Footer /></>} />
      <Route path="/catalog" element={<><Header /><Catalog /><Footer /></>} />
      <Route path="/catalog/:category" element={<><Header /><Catalog /><Footer /></>} />
      <Route path="/product/:id" element={<><Header /><ProductDetail /><Footer /></>} />
      <Route path="/news" element={<><Header /><News /><Footer /></>} />
      <Route path="/contact" element={<><Header /><Contact /><Footer /></>} />
      <Route path="/login" element={<><Header /><Login /><Footer /></>} />
      <Route 
        path="/admin/*" 
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <DocumentTitle />
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
